module.exports = __webpack_public_path__ + "static/media/select1@2x.f243105a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/select1@2x.png
// module id = 829
// module chunks = 0